import { styled } from "styled-components";
import posts from "../posts.json";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

function CategoriesBar() {
  const selectedCategory = useParams();
  const categories = Array.from(new Set(posts.map((p) => p.category))).sort();
  return (
    <CatWrapper>
      <Ul>
        <Li className={!selectedCategory.category ? "active" : ""}>
          <Link to={`/blogs`}>All</Link>
        </Li>
        {categories.map((c) => {
          return (
            <Li
              key={c}
              className={selectedCategory.category === c ? "active" : ""}
            >
              <Link to={`/blogs/${c}`}>{c}</Link>
            </Li>
          );
        })}
      </Ul>
    </CatWrapper>
  );
}

export default CategoriesBar;

const CatWrapper = styled.section`
  padding: 20px 0;
`;
const Ul = styled.ul`
  display: flex;
`;
const Li = styled.li`
  margin-left: 20px;
  font-size: 14px;
  &.active {
    font-weight: bold;
    a {
      color: rgb(4, 115, 234);
    }
  }
  a {
    color: rgb(82, 83, 85);
    text-decoration: none;
    &:hover {
      color: rgb(4, 115, 234);
    }
  }
`;
